import { ACCESS_HINTS } from "./access";
import { CAPACITY_HINTS } from "./capacity";
import { CATALOG_HINTS } from "./catalog";
import { GOALS_HINTS } from "./goals";
import { MEMBERS_HINTS } from "./members";
import { PROCESSES_TEMPLATES_HINTS } from "./processes-templates";
import { PROGRAMS_HINTS } from "./programs";
import { PROJECT_PANELS_HINTS } from "./project-panels";
import { PROJECTS_HINTS } from "./projects";
import { STATUS_LISTS_HINTS } from "./status-lists";
import { TEAMS_HINTS } from "./teams";
import type { THintTarget, THintTargets } from "./types";

/**
 * Every domain's rows. A domain PR adds its rows in its own file
 * (`cache-hints/<domain>.ts`) and one entry here, so two domain PRs never
 * edit the same rows. Every row now acts on the query cache alone, so none
 * reaches the root store.
 *
 * The keys match the backend's `cognota/notifications/cache_hints.py`
 * constants; change one only with the other. A hint for a key no row names
 * is ignored.
 */
export const HINT_TARGETS: THintTargets = assemble([
  ACCESS_HINTS,
  CAPACITY_HINTS,
  CATALOG_HINTS,
  GOALS_HINTS,
  MEMBERS_HINTS,
  PROCESSES_TEMPLATES_HINTS,
  PROGRAMS_HINTS,
  PROJECT_PANELS_HINTS,
  PROJECTS_HINTS,
  STATUS_LISTS_HINTS,
  TEAMS_HINTS,
]);

/** One table from the domains' rows. Two domains claiming one key is a mistake, not an override. */
export function assemble<THost>(domains: ReadonlyArray<THintTargets<THost>>): THintTargets<THost> {
  const rows: Record<string, THintTarget<THost>> = {};
  for (const domain of domains) {
    for (const [key, row] of Object.entries(domain)) {
      if (key in rows) throw new Error(`[cache-hints] two domains claim the hint "${key}"`);
      rows[key] = row;
    }
  }
  return rows;
}
